import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxChartModule, DxDropDownButtonModule, DxTextAreaModule, DxRangeSelectorModule, DxDataGridModule, DxButtonModule, DxPopupModule, DxSwitchModule } from 'node_modules/devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { TaskListPopupModule } from 'src/app/pages/task/task-list-popup/task-list-popup.module';
import { TaskPopupModule } from 'src/app/pages/task/task-popup/task-popup.module';
import { SharedModule } from 'src/app/pipes/shared-module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { GlobalizeNumberPipe } from 'src/app/pipes/globalize/globalize-number.pipe';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DxChartModule,
    DxDropDownButtonModule,
    DxTextAreaModule, DxRangeSelectorModule,
    DxDataGridModule,
    DevEpressCommonModule, SharedModule,
    DxButtonModule, DxPopupModule,
    TaskPopupModule, TaskListPopupModule,
    DxSwitchModule, BookmarkModule,
	ContainerComponent,
	GlobalizeNumberPipe,
  ]
})
export class DeepdiveV1Module { }
